import * as React from 'react';

const SvgCloseFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m18 7.45-1.413-1.413L12 10.587 7.437 6 6.013 7.412 10.588 12 6 16.55l1.412 1.412L12 13.412 16.563 18l1.425-1.413L13.413 12 18 7.45Z", fill: "currentColor" })));

export { SvgCloseFill as default };
